import Vue from 'vue';

Vue.filter('leftPad', (value, size, filling) => {
    if (value === null || value === undefined) { value = ''; }

    value = value + '';

    return value.padStart(size, filling);
});